import { Injectable } from '@angular/core';
import Serial from './../../app/plugins/serial';

@Injectable({
  providedIn: 'root'
})
export class ScaleProvider {
  async startListener(handleScaleWeight: any) {
    console.log('ddevbug scale start: ', handleScaleWeight);
    if (Serial) {
      console.log('ddevbug scale has Serial');
      await Serial.addListener(
        'serialPluginLogEvent',
        this.handleSerialLogEvent
      );
      await Serial.initialize();
      await Serial.addListener('scaleWeightEvent', handleScaleWeight);
      console.log('ddevbug scale after add listener');
    }
    // use for simulate the scale event on the browser
    // interval(500).subscribe(() => {
    //   handleScaleWeight({ new_weight: '0.453lb' });
    // });
  }

  stopListener() {
    try {
      console.log('ddevbug scale stop');
      if (Serial) {
        console.log('ddevbug scale stop before remove listeners');
        Serial.removeAllListeners();
        Serial.stop();
        console.log('ddevbug scale stop after remove listeners');
      }
    } catch (error) {
      // in web browser, it will throws error.
      console.log('ddevbug scale stop catch error: ', error);
      console.log(error);
    }
  }

  handleSerialLogEvent(event) {
    console.log('Handle Serial Log Event: ', event.data);
  }
}
